module.exports = __webpack_public_path__ + "static/media/i.6c3ce53d.png";